/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ValidateFreshnessCheckInput = {
  checkId: string | number;
  quantityDamaged?: number | null | undefined;
  quantityExpired?: number | null | undefined;
  quantityTooGoodToGo?: number | null | undefined;
};

export type ValidateFreshnessCheckMutationVariables = Exact<{
  input: Types.ValidateFreshnessCheckInput;
}>;

export type ValidateFreshnessCheckMutation = { validateFreshnessCheck: { success: boolean } };

export const ValidateFreshnessCheckDocument = gql`
  mutation ValidateFreshnessCheck($input: ValidateFreshnessCheckInput!) {
    validateFreshnessCheck(input: $input) {
      success
    }
  }
`;
export type ValidateFreshnessCheckMutationFn = Apollo.MutationFunction<
  ValidateFreshnessCheckMutation,
  ValidateFreshnessCheckMutationVariables
>;

/**
 * __useValidateFreshnessCheckMutation__
 *
 * To run a mutation, you first call `useValidateFreshnessCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFreshnessCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFreshnessCheckMutation, { data, loading, error }] = useValidateFreshnessCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateFreshnessCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateFreshnessCheckMutation,
    ValidateFreshnessCheckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateFreshnessCheckMutation,
    ValidateFreshnessCheckMutationVariables
  >(ValidateFreshnessCheckDocument, options);
}
export type ValidateFreshnessCheckMutationHookResult = ReturnType<
  typeof useValidateFreshnessCheckMutation
>;
export type ValidateFreshnessCheckMutationResult =
  Apollo.MutationResult<ValidateFreshnessCheckMutation>;
export type ValidateFreshnessCheckMutationOptions = Apollo.BaseMutationOptions<
  ValidateFreshnessCheckMutation,
  ValidateFreshnessCheckMutationVariables
>;
